
import CodeHelpers from './CodeHelpers.js'
import ParseExpression from './ParseExpression.js'

function ParseCall (parser) {
    this.parser = parser
    this.scanner = this.parser.scanner
    this.pcode = this.parser.pcode
    this.stable = this.parser.stable
    this.SC = this.parser.config
    this.hintHelper = this.parser.hintHelper
}

ParseCall.prototype = {
    callableCall (isFunction) {
        let callableToken
        let token
        let formalType
        let callable = null
        let parameters = []
        let copiedParamTypes = []
        let codeHelpers = new CodeHelpers(this.parser)
        let parseExpression = new ParseExpression(this.parser)

        callableToken = this.parser.expect(this.SC.IDENT)
        if (callableToken !== false) {
            callable = this.stable.getCallable(callableToken.lexema)
            parameters = callable.getExtra().listParams()
        }

        this.parser.expect(this.SC.OPEN_PAR)

        if (isFunction && this.parser.compile) {
            this.pcode.push(callable.getType(), 1, callableToken)
        }

        for (let i = 0; i < parameters.length; i++) {
            formalType = parameters[i].getType()
            let actualParamType
            if (formalType.isReference() || formalType.isArray()) {
                actualParamType = this.paramByReferenceOrArrayCopy(callableToken.lexema, formalType)
            } else {
                actualParamType = parseExpression.parse()
                if (!codeHelpers.semanticsAssignCast(formalType, actualParamType)) {
                    this.parser.error(callableToken, 'El tipo del parámetro actual no es compatible con el tipo del parámetro formal.')
                }
            }
            copiedParamTypes.push(actualParamType)

            if (i < parameters.length - 1) {
                // No es el ultimo parametro
                token = this.parser.expect(this.SC.COMMA)
                if (token === false) {
                    this.parser.error(callableToken, 'La cantidad de parámetros actuales no coincide con la cantidad de parámetros formales.')
                }
            }
        }

        if (this.parser.compile && callable !== null) {
            this.pcode.call(callable.getDisplacement(), callableToken)
        }

        if (this.parser.compile) {
            for (let i = parameters.length - 1; i >= 0; i--) {
                formalType = parameters[i].getType()
                if (formalType.isArray() && !formalType.isReference()) {
                    this.pcode.freea(copiedParamTypes[i], callableToken)
                }
                this.pcode.pop(copiedParamTypes[i], 1, callableToken)
            }
        }

        this.parser.expect(this.SC.CLOSE_PAR)

        if (!isFunction) {
            this.parser.expect(this.SC.SEMICOLON)
        }

        return callable.getType()
    },
    paramByReferenceOrArrayCopy (callableName, formalType) {
        let ident
        let identType
        let identDispl
        let codeHelpers = new CodeHelpers(this.parser)
        let parseExpression = new ParseExpression(this.parser)

        ident = this.parser.expect(this.SC.IDENT)
        if (ident === false) {
            if (formalType.isArray()) {
                this.parser.error(this.scanner.next(), 'Se esperaba un identificador ya que el parámetro formal es un arreglo.')
            } else {
                this.parser.error(this.scanner.next(), 'Se esperaba un identificador ya que el parámetro formal es una referencia.')
            }
            this.scanner.consume()
            return null
        }

        if (this.stable.hasVariable(ident.lexema)) {
            identType = this.stable.getVariable(ident.lexema).getType()
            identDispl = this.stable.getVariable(ident.lexema).getDisplacement()
        } else if (this.stable.hasParameter(ident.lexema)) {
            identType = this.stable.getParameter(ident.lexema).getType()
            identDispl = this.stable.getParameter(ident.lexema).getDisplacement()
        } else {
            this.parser.error(ident, 'Variable ' + ident.lexema + ' no declarada.')
            return null
        }

        if (!codeHelpers.semanticsAssignCast(formalType, identType)) {
            this.parser.error(ident, 'El tipo del parámetro actual no es compatible con el tipo del parámetro formal.')
        }

        if (formalType.isArray()) {
            if (formalType.isReference()) {
                if (this.parser.compile) {
                    this.pcode.load(identType, identDispl, ident)
                }
            } else {
                if (this.parser.compile) {
                    this.pcode.arrcpy(identType, identDispl, ident)
                }
            }
        } else {
            if (identType.isArray()) {
                // Se quiere pasar referencia a una componente
                let token = this.parser.expect(this.SC.INDEX_SEL_OPEN)

                if (token === false) {
                    this.parser.error(ident, 'La variable ' + ident.lexema + ' es un arreglo, se esperaba apertura de corchetes.')
                }

                token = this.scanner.next()

                let resultType = parseExpression.parse()

                if (!resultType.isInt()) {
                    this.parser.error(token, 'La expresión para acceder al arreglo debe ser de tipo entera.')
                }

                this.parser.expect(this.SC.INDEX_SEL_CLOSE)

                if (this.parser.compile) {
                    this.pcode.ldrefa(identType, identDispl, ident)
                }
            } else {
                // variable / parametro normal
                if (this.parser.compile) {
                    if (identType.isReference()) {
                        this.pcode.load(identType, identDispl, ident)
                    } else {
                        this.pcode.ldref(identType, identDispl, ident)
                    }
                }
            }
        }

        return identType
    }
}

export default ParseCall



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseCall.js